export default function calculateStandardValueEmissions(
  standardValueEmission: number,
  materalWeightInKg: number,
  considerationPeriod: number,
  totalArea: number
) {
  const totalEmission = standardValueEmission * materalWeightInKg;

  return {
    scaled: totalEmission / totalArea / considerationPeriod,
    total: totalEmission,
  };
}
